// removed by extract-text-webpack-plugin
module.exports = {"flex":"src-components-modules-CompetitorAlternatives-style----security-card-module---flex---mKABp display-flex borderRadius-l","raised":"src-components-modules-CompetitorAlternatives-style----security-card-module---raised---8RyNV bg-snow","circle":"src-components-modules-CompetitorAlternatives-style----security-card-module---circle---1NsqJ marginRight-m display-block overflow-hidden borderRadius-circle","content":"src-components-modules-CompetitorAlternatives-style----security-card-module---content---3DZfT flex-1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/CompetitorAlternatives/style/security-card.module.css
// module id = 1438
// module chunks = 260617349216052